const drink = [
  {
    id: 1,
    name: "Plain Roti",
    
    price: "£1.20"
  },
  {
    id: 2,
    name: "Butter Roti",
    
    price: "£1.50"
  },
  {
    id: 3,
    name: "Plain Naan",
    
    price: "£2.50"
  },
  {
    id: 4,
    name: "Butter Naan",
    
    price: "£2.60"
  },
  {
    id: 5,
    name: "Garlic Naan",
    
    price: "£2.80"
  },
  {
    id: 6,
    name: "Puri (x3)",
    
    price: "£1.80"
  },
  {
    id: 7,
    name: "Lachchha Paratha",
    
    price: "£2.60"
  },
  {
    id: 8,
    name: "Tawa Paratha",
    
    price: "£2.40"
  },
  {
    id: 9,
    name: "Aloo Paratha (with Raita)",
    
    price: "£3.20"
  },
  {
    id: 10,
    name: "Paneer Paratha (with Raita)",
    
    price: "£3.40"
  },
  {
    id: 11,
    name: "Gobi Paratha (with Raita)",
    
    price: "£3.20"
  }
];

export default drink;
